/**
 * PreSet 태스크 생성 시 L_DOC_CUST_SAVE 준비용 payload (MY PreSetIncorporation 패턴).
 * 실제 fetch(/prepare-documents) 호출은 sg/preset/components/PreSetWithdrawDirectorPanel 에서 수행.
 */
import { buildSgPresetPrepareDocumentItem } from '../../presetDocCustSave';
import { isOfficerWithdrawPresetDocument } from '../../appoint-director/composables/appointDirectorSigners';

export interface SelectionDocRow {
  tmpId?: number | null;
  templateName?: string;
}

export function buildWithdrawDirectorPresetPrepareDocuments(input: {
  selectionDocuments: SelectionDocRow[];
  /** toWithdrawDirectorTemplateVariables(formModel) */
  commonFormData: Record<string, any>;
  personName: string;
  entityCd?: string;
  /** DR (Withdraw Director) / Resignation Letter — 해임 대상 자동 사이너 JSON */
  withdrawingOfficerSignersJson?: string;
}) {
  return (input.selectionDocuments || [])
    .filter((d) => d.tmpId)
    .map((d) => {
      const templateName = d.templateName || '';
      const useOfficerSigner =
        !!input.withdrawingOfficerSignersJson && isOfficerWithdrawPresetDocument(templateName);
      const commonFormData = useOfficerSigner
        ? {
            ...input.commonFormData,
            signers: input.withdrawingOfficerSignersJson,
            Signers: input.withdrawingOfficerSignersJson,
          }
        : { ...input.commonFormData };

      return buildSgPresetPrepareDocumentItem({
        templateId: d.tmpId as number | string,
        templateName,
        personName: input.personName,
        commonFormData,
        entityCd: input.entityCd,
      });
    });
}
